export default __webpack_public_path__ + "static/media/banglesizeguide.65fadfb2.jpg";